<template>
	<div class="inner-banner">
		<img :src="banner.img" :alt="banner.title">
		<div class="txt wp">
			<h3>{{banner.title}}</h3>
			<p>{{banner.desc}}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "innerBanner",
	props: {
		banner: [Object]
	}
}
</script>

<style scoped lang="scss">
//inner-banner
.inner-banner {
	position: relative;
	img {
		display: block;
		width: 100%;
	}
	.txt {
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		color: $white2;
		h3 {
			font-family: 'Arial';
			font-style: normal;
			font-weight: 600;
			font-size: 36px;
			line-height: 150%;
			margin-bottom: 24px;
		}
		p {
			@extend .regular-16px;
			max-width: 480px;
		}
	}
}
@media only screen and (max-width: 767px) {
	.inner-banner .txt p {
		display: none;
	}
	.inner-banner .txt h3 {
		font-size: 24px;
		margin-bottom: 0;
	}
}
</style>
